import { useEffect, useRef } from 'react';
import { Badge } from '../../../design-system/components/Badge';
import { EmptyState } from '../../../shared/components/EmptyState';
import type { TranscriptSegment } from '../api';

interface ReadOnlyTranscriptProps {
  segments: readonly TranscriptSegment[] | null | undefined;
  anchorSegmentId?: string | null;
}

function formatTimestamp(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
  const total = Math.floor(seconds);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}

export function ReadOnlyTranscript({ segments, anchorSegmentId }: ReadOnlyTranscriptProps) {
  const anchorRef = useRef<HTMLLIElement | null>(null);

  useEffect(() => {
    if (anchorRef.current !== null) {
      anchorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [anchorSegmentId]);

  if (segments === null || segments === undefined || segments.length === 0) {
    return <EmptyState title="Sem transcript disponível" />;
  }

  return (
    <ol className="dash-transcript">
      {segments.map((s) => {
        const isAnchor = anchorSegmentId !== undefined && anchorSegmentId === s.id;
        return (
          <li
            key={s.id}
            ref={isAnchor ? anchorRef : undefined}
            className={'dash-transcript__item' + (isAnchor ? ' dash-transcript__item--anchor' : '')}
          >
            <div className="dash-transcript__meta">
              <Badge variant={s.speaker === 'closer' ? 'accent' : 'neutral'}>
                {s.speaker === 'closer' ? 'Closer' : 'Cliente'}
              </Badge>
              <span className="muted">{formatTimestamp(s.timestamp_start)}</span>
            </div>
            <p className="dash-transcript__text">{s.text}</p>
          </li>
        );
      })}
    </ol>
  );
}
